import { createFileRoute } from '@tanstack/react-router';
import { JourneysBroadcastsNewHandoff } from '@/pages/workspaces/broadcasts/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/broadcasts/new` URL. It forwards to the migrated form. The resolver belongs
 * here: this URL keeps the `journeys` segment, so a `/workspaces/last` sentinel resolves against
 * the embedded app's bundle before the forward builds its target.
 */
function JourneysBroadcastsNewRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysBroadcastsNewHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/broadcasts/new')({
  component: JourneysBroadcastsNewRoute,
});
